/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'
export type OutOfServiceAreaAlertCardAlertFragment = {
  __typename: 'VehicleSurveillanceNotification'
  id: string
  status: Types.TaskNotificationStatus
  notificationType: Types.TaskNotificationType
  employee: {
    __typename?: 'Employee'
    id: string
    firstName: string | null
    lastName: string | null
  } | null
  vehicle: {
    __typename?: 'Vehicle'
    id: string
    totalPassengersInVehicle: number | null
    inService: boolean | null
    label: number | null
    isSelfDriving: boolean
    hardwareConfiguration: {
      __typename?: 'HardwareConfiguration'
      tablet: { __typename?: 'Tablet'; phoneNumber: string | null } | null
    } | null
  } | null
  assigned: {
    __typename?: 'TaskStateChangeDetails'
    backofficeUserId: string | null
    backofficeUser: {
      __typename?: 'BackofficeUser'
      id: string
      username: string
    } | null
  } | null
  stateChanges: Array<{
    __typename: 'TaskStateChangeDetails'
    initiatedBySystem: boolean
    timestamp: string | null
    to: Types.TaskNotificationStatus
    backofficeUser: { __typename?: 'BackofficeUser'; username: string } | null
  }>
}

export const OutOfServiceAreaAlertCardAlertFragmentDoc = gql`
    fragment OutOfServiceAreaAlertCardAlert on VehicleSurveillanceNotification {
  id
  status
  employee {
    ...DefaultMetaNewAlertEmployee
  }
  vehicle {
    id
    ...DefaultMetaInProgressAlertVehicle
    ...BaseAlertCardVehicle
  }
  ...DefaultActionsOpenAlert
  ...DefaultActionsInProgressAlert
  ...DefaultAlertCardDataAlert
  ...BaseAlertCardTask
}
    `
